export default __webpack_public_path__ + "static/media/inIconDark.e0303271.svg";